import React, { useRef } from "react";
import { useTranslation } from "react-i18next";

import { projectStatus } from "@planzone/dto";
import { ColorPicker } from "@common/colorPicker";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { ColorPickerIcon } from "./colorPickerIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function Form({ submit }: Props) {
  const { t } = useTranslation();
  const [status, setStatus] = React.useState(projectStatus);

  return (
    <div className={styles.form}>
      <VisibilityWatcher>
        {(isVisible, show, hide) => (
          <div className={styles.wrapper}>
            <div onClick={isVisible ? hide : show} className={styles.iconBox}>
              {status.color ? (
                <div
                  className={styles.icon}
                  style={{ backgroundColor: status.color }}
                />
              ) : (
                <ColorPickerIcon className={styles.icon} />
              )}
            </div>
            {isVisible && (
              <div className={styles.colorPicker}>
                <ColorPicker
                  color={status.color}
                  pick={(color) => setStatus({ ...status, color })}
                  submit={() => submit(status)}
                />
              </div>
            )}
          </div>
        )}
      </VisibilityWatcher>
      <input
        className={styles.input}
        value={status.label}
        placeholder={t("utilityPage.projectPage.projectStatuses.placeholder")}
        onChange={({ target }) =>
          target.value.length < 40 &&
          setStatus({
            ...status,
            label: target.value,
          })
        }
        onKeyUp={({ key }) => key === "Enter" && submit(status)}
        autoFocus
      />
    </div>
  );
}

export { Form };
